"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationManager = void 0;
class ConfigurationManager {
}
exports.ConfigurationManager = ConfigurationManager;
ConfigurationManager.isModifyRegionOnlyMode = false;
ConfigurationManager.isPathRegionEnabled = false;
//# sourceMappingURL=ConfigurationManager.js.map